<!-- 总览页头部背景色 -->
<template>
  <div class="heads">
    <div class="left">
      <div class="times">
        <div class="hour_minute">
          <span>{{ hour }}:{{ minute }}</span>
        </div>
        <div class="year_yue">
          <p class="year">{{ year }}</p>
          <p class="period">{{ period }}</p>
        </div>
      </div>
    </div>
    <div class="middle" @click="toScreenDisplay">
      <!-- <img src="~@/assets/zong_lan_ye_img/head_logo.png" alt="" /> -->
      <img :src="homeLogo" alt="" :class="[homeTitle == '唐山市应急医疗配送平台' ? 'tangshanLF-log-class':'' ]" />
      <span>{{ homeTitle }}</span>
    </div>
    <div class="right">
      <div class="menu-item menu-icon-building" title="gbl加载" @click="btn_iconBuilding">
        <img src="~@/assets/images/icon-building.png" alt="" />
        <span></span>
      </div>
      <!-- 打开exe -->
      <div class="menu-item menu-item-openexe" title="虚拟拆装" @click="btn_openExe">
        <img src="~@/assets/zong_lan_ye_img/p1.png" alt="" />
        <span></span>
      </div>
      <div class="menu-item" title="问题反馈" @click="btn_feedback">
        <img src="~@/assets/zong_lan_ye_img/head_top_help.png" alt="" />
      </div>
      <div class="menu-item" title="消息通知" @click="btn_inform">
        <img src="~@/assets/zong_lan_ye_img/head_top_message.png" alt="" />
      </div>
      <div class="menu-item" title="联飞快送看板" @click="btn_oldVersion">
        <img src="~@/assets/zong_lan_ye_img/oldVersion1.png" alt="" />
      </div>
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="menu-item">
          <img src="~@/assets/zong_lan_ye_img/head_top_user.png" alt="" />
        </div>
        <el-dropdown-menu slot="dropdown" class="dropdown--user">
          <el-dropdown-item command="help">帮助中心</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--    <div class="left" @click="toScreenDisplay">-->
    <!-- <img src="~@/assets/zong_lan_ye_img/head_logo.png" alt="" /> -->
    <!--      <img :src="homeLogo" alt="" />-->
    <!-- <span>智能空域指挥控制系统</span> -->
    <!--      <span>{{ homeTitle }}</span>-->
    <!--    </div>-->
    <!--    <div class="right">-->
    <!--      &lt;!&ndash; 时间 &ndash;&gt;-->
    <!--      <div class="times">-->
    <!--        <div class="hour_minute">-->
    <!--          <span>{{ hour }}:{{ minute }}</span>-->
    <!--        </div>-->
    <!--        <div class="year_yue">-->
    <!--          <p class="year">{{ year }}</p>-->
    <!--          <p class="period">{{ period }}</p>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 排班 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_pup" v-if="false">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_zhibanbiao.png" alt="" />-->
    <!--        <span>值班表</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 通讯联络 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_communication" v-if="false">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_tongxun.png" alt="" />-->
    <!--        <span>通讯联络</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 安全飞行 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_safetyFly" v-if="false">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_fly.png" alt="" />-->
    <!--        <span>安全飞行</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 勤务等级 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_grade" v-if="false">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_zhanshi.svg" alt="" v-if="$store.state.home.startGrade == 2" />-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_level.png" alt="" v-else />-->
    <!--        <span>勤务等级</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 问题反馈 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_feedback">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_help.png" alt="" />-->
    <!--        <span>问题反馈</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 消息通知 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_inform">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_message.png" alt="" />-->
    <!--        <span>消息通知</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 报表导出 &ndash;&gt;-->
    <!--      <div class="menu-item" @click="btn_statistics" v-if="false">-->
    <!--        <img src="~@/assets/zong_lan_ye_img/head_top_export.png" alt="" />-->
    <!--        <span>报表导出</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 城市之鹰 &ndash;&gt;-->
    <!--      <el-dropdown trigger="click" @command="handleCommand">-->
    <!--        <div class="menu-item">-->
    <!--          <img src="~@/assets/zong_lan_ye_img/head_top_user.png" alt="" />-->
    <!--          <span>{{ user_info.name }}</span>-->
    <!--        </div>-->
    <!--        <el-dropdown-menu slot="dropdown" class="dropdown&#45;&#45;user">-->
    <!--          <el-dropdown-item command="help">帮助中心</el-dropdown-item>-->
    <!--          <el-dropdown-item command="logout">退出登录</el-dropdown-item>-->
    <!--        </el-dropdown-menu>-->
    <!--      </el-dropdown>-->
    <!--    </div>-->
  </div>
</template>

<script>
// 接口文件
import API from "@/api";
import { mapActions, mapGetters } from "vuex";
// 引用bus
import Bus from "@/assets/ligature.js";
import Moment from "moment";
import Lockr from 'lockr'
const { VUE_APP_HOME_TITLE } = process.env
console.log(process.env, 'bnm');
console.log(VUE_APP_HOME_TITLE, 'bnm');

export default {
  props: {
    returnData: {
      type: Number,
    },
  },
  data() {
    return {
      hour: null, //时
      minute: null, //分
      year: null, //年
      period: null, //周几
      pdata: null, //值班领导
      showDutyVisible: false, //值班表
      tableVisible: false, //报表导出
      FlyVisible: false, //安全飞行
      showmessage: false, //消息通知
      number: null, //消息数
      liaisonShow: false, //通讯联络
      times: null, //时间重复调用
      // homeTitle: '智能空域指挥控制系统-测试版', //首页顶部左侧大标题
      homeTitle: '智能空域指挥控制系统', //首页顶部左侧大标题
      homeLogo: 'image/head_logo.png', //首页顶部左侧logo
    };
  },
  watch: {
    returnData: function (vla, old) {
      console.log(vla, "当前勤务等级");
    },
    deep: true,
  },
  computed: {
    ...mapGetters(["user_info"]),
  },
  mounted() {
    // 标题
    setTimeout(() => {
      this.homeTitle = VUE_APP_HOME_TITLE;
      let sceneConfigData = window.localStorage.getItem('sceneConfigData');
      sceneConfigData = JSON.parse(sceneConfigData);
      console.log('sceneConfigData', sceneConfigData);
      
      if (sceneConfigData && sceneConfigData['home_title'] && sceneConfigData['home_title'] != '') {
        this.homeTitle = sceneConfigData['home_title'];
      }
      if (sceneConfigData && sceneConfigData['home_title_logo'] && sceneConfigData['home_title_logo'] != '') {
        this.homeLogo = `image/${sceneConfigData['home_title_logo']}`;
      }

      // 获取登录的用户
      let username = this.$store.state.user.user_info.username;
      console.log('顶部组件获取 username', username);
      if (username == "tangshanLF") {
        this.homeTitle = "唐山市应急医疗配送平台";
        this.homeLogo = `image/tangshanLF.png`;
      }
      console.log("this.homeTitle", this.homeTitle);
      

    }, 100);
    this.timer();
    setInterval(() => {
      this.timer();
    }, 30000);

    this.get_duty();
  },
  created() {
    // 调用Bus 刷新总览页值班情况
    Bus.$on("ToRequest", () => {
      this.get_duty();
      this.$emit("handleClose");
    });
  },
  methods: {
    ...mapActions("user", ["Logout"]),
    toScreenDisplay() {
      // window.open("#/screenDisplay", "_blank");
      this.$router.push("/screenDisplay");
    },
    timer() {
      // console.log("更新时间");
      const moment = Moment();
      // let today = new Date();

      /* let getDate = await API.WEATHER.getDate();
      let a = getDate.split(' ')
      // 时分
      let b = a[1]
      let c = b.split(':') */
      // 时
      // this.hour = c[0]
      this.hour = moment.format("HH");
      // 分
      // this.minute = c[1]
      this.minute = moment.format("mm");
      // 年月
      /* let d = a[0]
      let e = d.split('-') */
      this.year = moment.format("YYYY/MM/DD");
      this.period = this.week(moment.weekday());
      /* this.times = setTimeout(() =>{
        this.timer()  
      },30000) */
    },
    // 星期几
    week(weekNum) {
      let week = "";
      switch (weekNum) {
        case 0:
          week = "星期天";
          break;
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        case 6:
          week = "星期六";
          break;
      }
      return week;
    },
    // 排班信息
    async get_duty() {
      let data = await API.USER.GetDuty();
      this.pdata = data;
    },
    sheng(name) {
      // 判断是否为字符窜
      // 值班表字数过长时省略号表示
      if (typeof name == "string") {
        // 判断长度有没有超过4个字符窜
        if (name.length > 4) {
          const a = name.slice(0, 3) + "...";
          return a;
        }
      }
      return name;
    },
    // 值班表
    btn_pup() {
      this.$emit("pup", 4);
    },
    //勤务等级
    btn_grade() {
      this.$emit("pup", 5);
    },
    // 问题反馈
    btn_feedback() {
      this.$emit("pup", 1);
    },
    // 安全飞行
    btn_safetyFly() {
      this.$emit("pup", 6);
    },
    // 通讯联络
    btn_communication() {
      this.$emit("pup", 7);
    },
    // 消息通知
    btn_inform() {
      this.$emit("pup", 8);
    },
    //报表统计
    btn_statistics() {
      this.$emit("pup", 9);
    },
    // 退出登录
    handle_logout() {
      this.$el_confirm("确定要退出登录吗？", () => {
        this.Logout();
        sessionStorage.clear();
        localStorage.clear();
      });
    },
    handleCommand(cmd) {
      switch (cmd) {
        case "logout":
          this.handle_logout();
          break;

        case "help":
          window.open("http://32.128.6.51");
          break;
      }
    },
    btn_iconBuilding() {
      this.$emit("iconBuilding");
    },
    // 打开exe
    btn_openExe() {
      // window.open("universalLink://");
      let token = JSON.parse(localStorage.getItem("user_info")).data['mmc-identity'];
      window.open("ZhzVSim://" + token + "#", '_blank');
    },
    // 跳转到旧版本
    btn_oldVersion() {
      // window.open("http://39.108.218.253/hawk_web", '_blank');
      // window.open("http://39.108.218.253/hawk_web", '_blank');
      // window.open(`${process.env.VUE_APP_LINK_URL}/hawk_web`, "_blank");
      let token = Lockr.get("IDENTITY")
      window.open(`${process.env.VUE_APP_LINK_URL}/lfks_dashboard/?${token}`, "_self");
    },
    // jump
    btn_openJump() {
      $.get("http://60.205.91.11:9090/login/loginIn?password=PUtoIzQ1NiEjMnIx&userId=bGdxczAx&forceLogin=true", function (data) {
        console.log('60.205.91.11:9090 登录返回值', data);
        // window.open(`http://60.205.91.11:9090/ltstation_V4.html`);
        // localStorage.setItem("mapTiandituKey", "82b4c57341062c4a024ab9e9fb3f60b2");
        // localStorage.setItem("token", "bGdxczAx");
        // localStorage.setItem("logoDesc", "82b4c57341062c4a024ab9e9fb3f60b2");
        // localStorage.setItem("autoPosition", "82b4c57341062c4a024ab9e9fb3f60b2");
        // localStorage.setItem("logoBaseUrl", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAnCAYAAABwtnr/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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");
        // localStorage.setItem("ag_script_item", "");
        setTimeout(() => {
          window.open(`http://60.205.91.11:9090/ltstation_V4.html`, "_self");
          // let newWindow = window.open(`http://60.205.91.11:9090/ltstation_V4.html`);
          localStorage.setItem("mapTiandituKey", "82b4c57341062c4a024ab9e9fb3f60b2");
          localStorage.setItem("token", "bGdxczAx");
          localStorage.setItem("logoDesc", "82b4c57341062c4a024ab9e9fb3f60b2");
          localStorage.setItem("autoPosition", "82b4c57341062c4a024ab9e9fb3f60b2");
          localStorage.setItem("logoBaseUrl", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAnCAYAAABwtnr/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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");
          localStorage.setItem("ag_script_item", "");

          let data = {
            "mapTiandituKey": "82b4c57341062c4a024ab9e9fb3f60b2",
            "token": "bGdxczAx",
            "logoDesc": "理工全盛低空无人机",
            "autoPosition": "0",
            "logoBaseUrl": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAnCAYAAABwtnr/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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",
            "ag_script_item": ""
          };
          newWindow.postMessage(data, '*');

          setInterval(() => {
            console.log('xxxxxxxxxxxxxxxx');
            
          }, 100);

          window.addEventListener('message', function (event) {
            let receivedData = event.data;
            // 处理接收到的数据并存储到新页面的 localStorage 中
            console.log('处理接收到的数据并存储到新页面的 localStorage 中', event);

          });

        }, 100);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.heads {
  width: 100%;
  height: 61px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-image: url("~@/assets/zong_lan_ye_img/head_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  align-items: center;
  top: 0;
  z-index: 10;
  left: 0;
  padding: 0 10px;

  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: -18px;
    cursor: pointer;

    .times {
      display: flex;
      justify-content: center;
      align-items: center;

      .hour_minute {
        font-size: 28px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #FFFFFF;
        margin-right: 10px;
      }

      .year {
        font-size: 14px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: 500;
        color: #FFFFFF;
      }

      .period {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #b9b8b8;
        margin-top: 3px;
      }
    }

    img {
      width: 38px;
      height: 34px;
      margin-left: 79px;
      margin-right: 20px;
      margin-top: 6px;
    }

    span {
      color: white;
      font-weight: 600;
      font-size: 26px;
      line-height: 37px;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
  }

  .right {
    display: flex;
    flex-direction: row;
    margin-top: -18px;
    margin-right: 5px;

    .times {
      display: flex;
      flex-direction: row;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      margin-right: 100px;
      align-items: center;
      margin-top: -10px;

      .hour_minute {
        font-size: 36px;
        line-height: 42px;
        margin-right: 5px;
      }

      .year_yue {
        display: flex;
        flex-direction: column;

        .year {
          font-size: 14px;
          line-height: 16px;
        }

        .period {
          font-size: 12px;
          line-height: 17px;
        }
      }
    }

    .menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 15px;
      margin-right: 15px;
      cursor: pointer;

      img {
        width: 31px;
        height: 30px;
      }

      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
      }
    }

    .menu-item-openexe {
      img {
        width: 26px;
        height: 26px;
        margin-top: 3px;
      }
    }
    .menu-icon-building{
      img {
        width: 26px;
        height: 26px;
        margin-top: 3px;
      }
    }
  }

  .middle {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: fixed;
    left: 30%;
    // border:1px solid #ff0000;
    width: 40%;

    img {
      width: 28px;
      height: 26px;
    }

    span {
      //width: 500px;
      //height: 54px;
      //background: rgba(0,255,192,0.15);
      //border: 1px solid #00F5FF;
      margin-left: 10px;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
    .tangshanLF-log-class{
      width: 120px !important;
      border-radius: 4px;
    }
  }
}

// 值班样式
.be_on_duty {
  justify-content: space-between;

  // 排班表
  .paiban {
    margin-top: 23px;
    padding-top: 4px;
    box-sizing: border-box;
    width: 290px;
    height: 63px;
    position: relative;
    z-index: 1;
    // justify-content: center;
    flex-direction: column;
    align-items: center;

    .Scheduling_bj {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 39px;
      background-image: url("~@/assets/zong_lan_ye_img/time_v2.png");
      background-size: 100% 100%;
      z-index: 5;
    }

    .Scheduling_name {
      width: 230px;
      margin: 0 0 5px 0;
      display: flex;
      justify-content: center;

      .position {
        z-index: 10;
      }
    }

    .mingzi {
      display: inline-block;
      width: 50px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
    }
  }

  // 排便表
  .working_schedule {
    margin-top: 23px;
    // padding-top: 4px;
    // box-sizing: border-box;
    width: 100px;
    height: 58px;
    position: relative;
    z-index: 1;
    cursor: pointer;

    .working_schedule_bj {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 33px;
      background-image: url("~@/assets/zong_lan_ye_img/paiban_bjv2.png");
      background-size: 100% 100%;
      z-index: 5;
    }

    .img {
      width: 100%;
      padding-top: 11px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
    }

    .working_schedule_btn {
      text-align: center;
      position: relative;
    }
  }
}

// 标题
.bioati {
  position: absolute;
  left: 35.5%;
  width: 576px;
  box-sizing: border-box;
  padding: 12px 0 0 0;
  z-index: 10;
  display: flex;
  justify-content: center;
}

// 功能
.function {
  position: absolute;
  right: 0;
  width: 661px;
  box-sizing: border-box;
  padding: 0 20px 0 52px;

  .Popout {
    margin-top: 23px;
    width: 102px;
    height: 58px;
    position: relative;
    cursor: pointer;

    .Popout_bj {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 39px;
      width: 102px;
      background-image: url("~@/assets/zong_lan_ye_img/gongneng_v2.png");
      background-size: 100% 100%;
      // z-index: 2;
    }

    .icon {
      width: 100%;
      padding-top: 6px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      position: relative;
      padding: 0 0 0 17px;
      box-sizing: border-box;
    }

    &:hover {
      .Popout_bj {
        background-image: url("~@/assets/zong_lan_ye_img/gongneng_bj.png");
      }

      .fontFive {
        color: #c4e7ff;
      }
    }
  }
}

// 公共样式
.flex {
  display: flex;
}

/deep/ .el-button {
  padding: 0;
  background-color: transparent !important;
  border: 0px solid;
}

.fontOne {
  font-size: 14px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #ffffff;
}

.fontTwo {
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  color: #b3c7d9;
  line-height: 22px;
}

.fontThree {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  z-index: 5;
}

.fontFour {
  width: 230px;
  font-size: 58px;
  font-family: YouSheBiaoTiHei;
  color: #ffffff;
  line-height: 75px;
  letter-spacing: 4px;
  background: linear-gradient(135deg,
      #e3aa77 0%,
      #f5cda9 38%,
      #f9ecd3 58%,
      #fcdbb1 79%,
      #edb07a 100%);
  // text-shadow: 0px 4px 4px #03081F;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fontFive {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: relative;
  margin: 7px 0 0 0;
  box-sizing: border-box;
  padding: 0 0 0 14px;
}
</style>
